module.exports = __webpack_public_path__ + "assets/img/plant-1.73d64853.png";